import { defineModule } from "../define.ts";

/**
 * School calendar, bell schedules and class timetables (PMU-265). One calendar per school (terms,
 * holidays, no-school days, early releases, late starts, events), whose closures and moved days
 * also drive the buses; bell schedules with period codes; a weekly timetable per class. A school
 * may share a public page, an iCal feed and an embed, item by item. On for every school.
 */
export const calendar = defineModule({
  id: "calendar",
  name: "Calendar and timetables",
  version: "0.1.0",
  description: "The school calendar, bell schedules and class timetables, shareable publicly.",
  core: true,
  grants: {
    "calendar:manage": ["org_admin", "site_admin"],
    "calendar:view": ["org_admin", "site_admin", "door_staff", "teacher", "auditor"],
  },
});
